import { useDisclosure } from '@heroui/react';
import { useState, useCallback } from 'react';
import type { UserListItem } from '@/types';

export function useUserRoles() {
  const { isOpen: isRolesModalOpen, onOpen: onRolesModalOpen, onOpenChange: onRolesModalOpenChange } = useDisclosure();
  const [selectedUser, setSelectedUser] = useState<UserListItem | null>(null);

  const openRolesModal = useCallback((user: UserListItem) => {
    setSelectedUser(user);
    onRolesModalOpen();
  }, [onRolesModalOpen]);

  const closeRolesModal = useCallback(() => {
    setSelectedUser(null);
    onRolesModalOpenChange();
  }, [onRolesModalOpenChange]);

  return {
    isRolesModalOpen,
    selectedUser,
    openRolesModal,
    closeRolesModal,
    onRolesModalOpenChange
  };
}
